import { render } from "./app-modal-copy-master-business.vue?vue&type=template&id=1d39d330"
import script from "./app-modal-copy-master-business.vue?vue&type=script&lang=js"
export * from "./app-modal-copy-master-business.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__